/**
 *
 * @license
 * Copyright 2017 SAP Ariba
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 *
 *
 */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StepperComponent} from './stepper.component';
import {StepComponent} from './step/step.component';
import {AWCoreComponentModule} from '../../core/core.module';

@NgModule({
    declarations: [
        StepComponent,
        StepperComponent

    ],
    imports: [
        CommonModule,
        AWCoreComponentModule,
    ],
    entryComponents: [
        StepComponent,
        StepperComponent
    ],
    exports: [
        StepComponent,
        StepperComponent
    ],
    providers: []
})
export class AWStepperModule
{
}


